import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CREstimateDefaultValuesBody,
  CREstimateDefaultValuesBodyAPI,
  CREstimateDefaultValuesKey,
  CREstimateDefaultValuesSummary,
  CREstimateDefaultValuesSummaryAPI,
  EstimateDefaultValuesActions,
  EstimateDefaultValuesState,
} from './types';

type AnyEstimateDefaultValues =
  | CREstimateDefaultValuesKey
  | CREstimateDefaultValuesSummary
  | CREstimateDefaultValuesBody
  | undefined;

function sameKeyEstimateDefaultValues(
  a: AnyEstimateDefaultValues,
  b: AnyEstimateDefaultValues,
): boolean {
  return (
    a?.siteId === b?.siteId &&
    a?.chargeableTypeId === b?.chargeableTypeId &&
    a?.estimateItemId === b?.estimateItemId
  );
}

function getEndpointEstimateDefaultValues(key: AnyEstimateDefaultValues): string {
  return key
    ? `/estimate-default-values/${key.siteId}/${key.chargeableTypeId}/${key.estimateItemId}/`
    : '/estimate-default-values/';
}

function parseEstimateDefaultValuesSummary(
  estimateDefaultValuesSummary: CREstimateDefaultValuesSummaryAPI,
): CREstimateDefaultValuesSummary {
  return estimateDefaultValuesSummary;
}

function parseEstimateDefaultValuesBody(
  estimateDefaultValuesDetail: CREstimateDefaultValuesBodyAPI,
): CREstimateDefaultValuesBody {
  return estimateDefaultValuesDetail;
}

const estimateDefaultValuesStateSelector = (state: any): EstimateDefaultValuesState =>
  state.estimateDefaultValues;

const estimateDefaultValuesKeySelector = ({
  siteId,
  chargeableTypeId,
  estimateItemId,
}:
  | CREstimateDefaultValuesBody
  | CREstimateDefaultValuesSummary): CREstimateDefaultValuesKey => ({
  siteId,
  chargeableTypeId,
  estimateItemId,
});

function mergeEstimateDefaultValuesBody(
  lastBody: CREstimateDefaultValuesBody,
  currentBody: CREstimateDefaultValuesBody,
) {
  return currentBody;
}

function combineSummaryBodyEstimateDefaultValues(
  summary?: CREstimateDefaultValuesSummary,
  body?: CREstimateDefaultValuesBody,
): CREstimateDefaultValuesSummary {
  const merge = mergeSummaryBodyField(summary, body);

  return {
    ...summary,
    rowKey: summary?.rowKey ?? body?.rowKey ?? '',
    siteId: merge('siteId'),
    chargeableTypeId: merge('chargeableTypeId'),
    estimateItemId: merge('estimateItemId'),
    shown: merge('shown'),
    costRate: merge('costRate'),
    markUp: merge('markUp'),
    quantity: merge('quantity'),
    useDefault: merge('useDefault'),
    quantityDisplay: merge('quantityDisplay'),
    costRateDisplay: merge('costRateDisplay'),
    shownDisplay: merge('shownDisplay'),
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'estimateDefaultValues',
  getEndpointEstimateDefaultValues,
  estimateDefaultValuesStateSelector,
  sameKeyEstimateDefaultValues,
  parseEstimateDefaultValuesBody,
  parseEstimateDefaultValuesSummary,
  mergeEstimateDefaultValuesBody,
  combineSummaryBodyEstimateDefaultValues,
);

const estimateDefaultValuesActions: EstimateDefaultValuesActions = actions;
export * from './types';
export {
  estimateDefaultValuesActions,
  reducer as estimateDefaultValuesReducer,
  watches as estimateDefaultValuesWatches,
  estimateDefaultValuesStateSelector,
  estimateDefaultValuesKeySelector,
};
